import React from 'react';
import "./select-label.css"


const getNameOfSelect = (selectedLabelColor) => {
  switch (selectedLabelColor) {
    case "yellow":
      return "Yellow is selected";
    case "red":
      return "Red is selected";
    case "green":
      return "Green is selected";
    default:
      return "Select label color";
  }
};

const getColor = color => {
  switch(color) {
    case "yellow":
      return "#fcff46";
    case "red":
      return "#ff3b31";
    case "green":
      return "#00a900";
    default:
      return "#d4d4d4";
  }
};

const SelectLabelComponent = (
  {
    toggleLabelSelection,
    selectedLabelColor,
    labelSelectionIsShown,
    selectLabelColor
  }
  ) => {
  return (
    <div style={{ position: "relative" }}>
      <div
        className="select_label__setLabel"
        onClick={e => {
          e.stopPropagation();
          toggleLabelSelection()
        }}
        style={{
          backgroundColor: getColor(selectedLabelColor)
        }}
      >
        <div>{getNameOfSelect(selectedLabelColor)}</div>
        <i className="fas fa-angle-down" />
      </div>
      <div
        className="select_label__labels"
        style={{ display: labelSelectionIsShown ? "flex" : "none" }}
      >
        <div
          className="select_label__labels__label yellow"
          onClick={e => {e.stopPropagation(); selectLabelColor("yellow"); }}
        />
        <div
          className="select_label__labels__label green"
          onClick={e => { e.stopPropagation(); selectLabelColor("green"); }}
        />
        <div
          className="select_label__labels__label red"
          onClick={e => { e.stopPropagation(); selectLabelColor("red"); }}
        />
        <div
          className="select_label__labels__label grey"
          onClick={e => { e.stopPropagation(); selectLabelColor(""); }}
          style={{ marginBottom: "0" }}
        >No label</div>
      </div>
    </div>
  )
};

export default SelectLabelComponent


// WEBPACK FOOTER //
// ./src/modules/select-label/select-label-component.js